<template>
  <div class="bui-entity-listing-page account-editor-redesign">
    <div class="account-editor-redesign__inner">
      <!-- Page header -->
      <header class="pe-header">
        <div class="pe-header__left">
          <div class="pe-header__title-row">
            <h1 class="bui-page-title">Account Editor</h1>
            <button
              type="button"
              class="pe-header__refresh"
              aria-label="Refresh account data"
              data-testid="account-refresh"
              @click="loadAccount()"
            >
              <PhArrowsClockwise :size="22" weight="bold" />
            </button>
          </div>
          <div class="pe-header__subtitle">{{ form.name }}</div>
        </div>
      </header>

      <!-- Two-column editor grid -->
      <section class="editor-grid">
        <!-- LEFT COLUMN -->
        <div class="editor-col">
          <InfoCard>
            <template #title>
              <h2 class="info-card__title-text">Account Details</h2>
            </template>

            <StatusBar :errorMessage="errorMessage" />

            <div class="field-content">
              <div class="d-flex field-row">
                <label class="basis-1/2 text-sm font-bold">Name &#9733;</label>
                <div class="basis-1/2 ae-value">{{ form.name }}</div>
              </div>
              <div class="d-flex field-row">
                <label for="ae-email" class="basis-1/2 text-sm font-bold">Support Email Address</label>
                <TextField id="ae-email" v-model="values.email" class="basis-1/2" width="100%" />
              </div>
              <div class="d-flex field-row">
                <label class="basis-1/2 text-sm font-bold">Default Playlist</label>
                <div class="basis-1/2 ae-inline-dialog">
                  <AddPlaylistDialog v-if="!form.defaultPlaylist" :showBtn="true" @save="addPlaylist($event)" />
                  <div v-if="form.defaultPlaylist" class="ae-playlist-value">
                    <span class="ae-value">{{ form.defaultPlaylist?.name }}</span>
                    <AddPlaylistDialog :showBtn="false" @save="addPlaylist($event)" />
                    <button type="button" class="ue-link" @click="removePlaylist()">Remove</button>
                  </div>
                </div>
              </div>
              <div class="d-flex field-row field-row--top">
                <label class="basis-1/2 text-sm font-bold" data-testid="account-banner-image-label">Banner Image</label>
                <div class="basis-1/2 ae-banner">
                  <template v-if="form.bannerImage">
                    <img class="ae-banner__img" :src="form.bannerImage.publicUrl" alt="Account banner image" />
                    <button type="button" class="ue-link" @click="removeBannerImage()">Remove</button>
                  </template>
                  <ButtonCustomized v-if="!form.bannerImage" label="Upload New" cta @click="openFile()" />
                  <input type="file" hidden ref="inputFile" @change="onFileChange($event)">
                </div>
              </div>
            </div>
          </InfoCard>
        </div>

        <!-- RIGHT COLUMN -->
        <div class="editor-col">
          <InfoCard title="Appearance" class="appearance-card">
            <p class="appearance-hint">
              Choose how the portal looks for you. Your choice is saved to your
              account and applies on all of your devices.
            </p>
            <ThemeSwitcher />
          </InfoCard>
        </div>
      </section>

      <!-- Sticky footer -->
      <footer class="editor-footer">
        <div class="editor-footer__inner">
          <ButtonCustomized label="Exit" data-testid="account-exit" v-if="!hasChanges" @click="onExit" ctaSecondary />
          <BeforeExitDialogue v-if="hasChanges" @save="submitAndExit" @exit="onExit" />
          <ButtonCustomized label="Save" data-testid="account-save" cta @click="onSubmit" :disabled="!hasChanges" />
          <Saving ref="savingDialog" />
        </div>
      </footer>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { onBeforeMount, onMounted, onUnmounted, ref, watchEffect } from 'vue'
import { PhArrowsClockwise } from '@phosphor-icons/vue';
import TextField from "@/components/form-fields/TextField.vue";
import ButtonCustomized from "@/components/form-fields/ButtonCustomized.vue";
import StatusBar from "@/components/form-fields/StatusBar/StatusBar.vue";
import useNotifications from "@/components/Notifications/composables/notifications";
import router from '@/router';
import { onBeforeRouteLeave, useRoute } from 'vue-router'
import useAccountEditor from './AccountEditorHelper'
import BeforeExitDialogue from '@/components/Dialog/BeforeExitDialog/BeforeExitDialogue.vue'
import Saving from '@/components/Dialog/SavingDialog/Saving.vue'
import AddPlaylistDialog from './AddPlaylist/AddPlaylistDialog.vue';
import { deleteBannerImage, submitUploadBannerImage } from '@/helpers/api/user';
import InfoCard from '@/components/bui/molecules/InfoCard/InfoCard.vue';
import ThemeSwitcher from '@/components/ThemeProvider/ThemeSwitcher.vue';

const  inputFile = ref ()
const savingDialog = ref()
const route = useRoute()
const notification = useNotifications();
const {  values, submitForm, isSuccess, loadAccount,form,
  hasChanges, errorMessage, removeBeforeLoad, isLoading, locationId,locationModel,accountDetails
} = useAccountEditor();
onBeforeMount(() => {
  loadAccount()
})
onUnmounted(() => {
  removeBeforeLoad()
})
onBeforeRouteLeave((to, from) => {
  if (hasChanges.value) {
    const answer = window.confirm(
      'Changes you made may not be saved.'
    )
    if (!answer) return false
  }
})

async function submitAndExit() {
  savingDialog.value.open()
  await submitForm();
  savingDialog.value.close()
  if (isSuccess.value === true) {
    notification.success('Account updated successfully!');
    removeBeforeLoad();
    router.push({ path: '/' })
  }
}
async function onSubmit() {
 savingDialog.value.open()
  await submitForm();
  savingDialog.value.close()
  if (isSuccess.value === true) {
    removeBeforeLoad();
    notification.success('Account updated successfully!');
  }
}
function onExit() {
  removeBeforeLoad()
  router.push({ path: '/' })
}
function addPlaylist (playlist :any )
{ console.log('playlist');
console.log(playlist[0])
  form.value.defaultPlaylist = playlist[0] ;
  hasChanges.value = true
}
function removePlaylist () {
  form.value.defaultPlaylist = null ;
  hasChanges.value = true
}
function openFile(){
  inputFile.value.click()
}
function onFileChange (event: any)
{
  submitUploadBannerImage(event.target.files[0]).then(res => {
      if (res.success==true)
      {      notification.success('Banner image updated successfully!');
          loadAccount()
      }

})

}
function removeBannerImage () {
  deleteBannerImage().then(res=> {
      form.value.bannerImage = null
  })
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/bui-editor-template';

/* Outer wrapper: paints the BUI page surface edge-to-edge (see the note in
   PlayerEditorView — `.bui-entity-listing-page` is wired in PageLayout.vue). */
.account-editor-redesign {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  background: var(--bui-page-fill, #ff007b);
  color: var(--bui-page-head, #fffcfd);
  padding: var(--bui-page-pad-y, 32px) var(--bui-page-pad-x, 48px) 5rem;
  box-sizing: border-box;

  @media (max-width: 1100px) {
    padding-left: 24px;
    padding-right: 24px;
  }
}

.account-editor-redesign__inner {
  display: flex;
  flex-direction: column;
  gap: var(--bui-page-section-gap, 24px);
  width: 100%;
  flex: 1 1 auto;
  min-width: 0;
}

.ae-value {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--bui-tbl-row-text, #2a2969);
}

.ae-playlist-value {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
}

/* Inline dialog expanders (Add Playlist) hug content and align left. */
.ae-inline-dialog {
  :deep(> .flex),
  :deep(.flex) {
    display: inline-flex;
    width: auto;
    flex: 0 0 auto;
    justify-content: flex-start;
  }

  :deep(a) {
    color: var(--bui-tbl-row-link, #4b1886);
    cursor: pointer;
  }
}

.ae-banner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;

  &__img {
    max-width: 100%;
    border-radius: var(--bui-ter-radius, 8px);
  }

  /* Upload button hugs content. */
  :deep(.button) {
    width: fit-content;
  }
}

.appearance-card {
  max-width: 26rem;
}

.appearance-hint {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: color-mix(in srgb, var(--bui-tbl-row-text, #2a2969) 75%, transparent);
}
</style>
